import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Typography,
} from "@mhome/ui";
import { Copy, ExternalLink } from "lucide-react";

const ShareAutomationDialog = ({ open, onClose, shareLink, onCopy }) => {
  return (
    <Dialog open={open} onClose={onClose} variant="pops">
      <DialogTitle>Share Automation</DialogTitle>
      <DialogContent>
        <div className="flex items-center gap-2 mt-2">
          <TextField
            value={shareLink}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            size="small"
          />
          <IconButton onClick={onCopy} aria-label="Copy link">
            <Copy className="h-4 w-4" />
          </IconButton>
          <IconButton
            href={shareLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open link"
            className="text-primary"
          >
            <ExternalLink className="h-4 w-4" />
          </IconButton>
        </div>

        <Typography variant="caption" className="mt-4 text-muted-foreground">
          Send this link to other users. They can apply the same automation for
          their space.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outline" onClick={onClose} className="normal-case">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareAutomationDialog;
